import { useEffect } from 'react'

import i18n from 'modules/core/lib/i18n'

import { useFormProvider } from 'modules/processes/components/ItemWizard/Providers/form'
import Form from 'modules/processes/components/ItemWizard/components/Form'
import Assignees from 'modules/processes/components/ItemWizard/components/Form/Items/Assignees'
import Attachments from 'modules/processes/components/ItemWizard/components/Form/Items/Attachment'
import Deadline from 'modules/processes/components/ItemWizard/components/Form/Items/Deadline'
import Description from 'modules/processes/components/ItemWizard/components/Form/Items/Description'
import Mandatory from 'modules/processes/components/ItemWizard/components/Form/Items/Mandatory'
import Title from 'modules/processes/components/ItemWizard/components/Form/Items/Title'
import { DataCollectionCategories } from 'modules/processes/domain'
import { TaskConfigurationTypes } from 'modules/processes/lib/taskConfigurationTypes'

import CustomFieldSelector from './CustomFieldSelector'

const DEFAULT_DATA = () => ({
  title: i18n.t(
    'processes.process_settings.wizard.tasks.types.additional_employee_info.form.defaults.title',
    {
      emoji: '\u{270D}',
    }
  ),
  description: i18n.t(
    'processes.process_settings.wizard.tasks.types.additional_employee_info.form.defaults.description',
    { emoji: '\u{1F44B}' }
  ),
})

const Content = () => {
  const { associatedTaskItem: item, form, initializeForm } = useFormProvider()
  const defaultData = DEFAULT_DATA()

  useEffect(() => {
    initializeForm(DataCollectionCategories.employee_questions_cf, {
      task_type: TaskConfigurationTypes.DataCollection,
      title: item ? item.title : defaultData.title,
      instruction: item ? item.instruction : defaultData.description,
    })
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  if (!form) return null

  return (
    <Form
      items={{
        title: <Title />,
        assignees: <Assignees />,
        fieldSelector: <CustomFieldSelector />,
        description: <Description />,
        deadline: <Deadline />,
        attachments: <Attachments />,
        mandatory: <Mandatory />,
      }}
    />
  )
}

export default Content
